import Head from 'next/head'
import cloneDeep from 'lodash/cloneDeep'

export const DirectorySEO = ({ metaTagsData, directoriesCanonicalUrl }) => {
  const pageTitle = metaTagsData.find((metaTag) => metaTag.property === 'og:title')
  // Next Head only sets tags with name so we must use id or property value if name is not present.
  const metaTags =
    metaTagsData &&
    metaTagsData.length > 0 &&
    metaTagsData.map((metaTagData, i) => {
      const newMetaTagData = cloneDeep(metaTagData)
      // Remove nulls/undefineds and typename from props
      Object.keys(newMetaTagData).forEach(
        (key) => newMetaTagData[key] == null && delete newMetaTagData[key]
      )
      delete newMetaTagData.__typename
      return <meta key={i} {...newMetaTagData} />
    })
  return (
    <Head>
      <>
        <title>{pageTitle && pageTitle.content}</title>
        <script async='async' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js'></script>
        {metaTags}
        {directoriesCanonicalUrl && <link href={directoriesCanonicalUrl} rel='canonical' />}
      </>
    </Head>
  )
}

export default DirectorySEO
